import { Button, DatePicker, Select, message } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Loadingbox from "../../component/loadingbox";
import PageHeader from "../../component/pageHeaders";
import { API } from "../../config/API";
import { DELETE, POST, PUT } from "../../utils/apirequest";
import DataTable from "./component/datatable";
import editons from "./component/editions.json";
import Preview from "./component/preview";
import "./styles.css";

function EPaperScreeen() {
  const navigation = useNavigate();
  const location = useLocation();
  const [isloading, setIsloading] = useState(true);
  const [data, setData] = useState([]);
  const [item, setItem] = useState({});
  const [preview, setPreview] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [meta, setMeta] = useState(0);
  const [filter, setFilter] = useState({ 
    start: 0, 
    limit: 10,
    edition: undefined,
    createdAt: undefined 
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlPage = parseInt(params.get("page") || "1");
    const urlLimit = parseInt(params.get("limit") || "10");
    const urlEdition = params.get("edition") || undefined;
    const urlDate = params.get("date") || undefined;

    const urlStart = urlPage === 1 ? 0 : (urlPage - 1) * urlLimit;

    const initialFilter: any = { 
      start: urlStart, 
      limit: urlLimit,
      edition: urlEdition,
      createdAt: urlDate ? new Date(urlDate) : undefined
    };

    setPage(urlPage);
    setPageSize(urlLimit);
    setFilter(initialFilter);
  }, []); 

  useEffect(() => {
    loadData();
  }, [filter]);

  const loadData = async (customFilters?: any) => {
    setIsloading(true);
    try {
      const URL = API.EPAPER_LIST;
      
      const filtersToUse = customFilters || filter;
      
      const cleanFilter = Object.fromEntries(
        Object.entries(filtersToUse).filter(([_, value]) => value !== undefined && value !== null)
      );      
      const res: any = await POST(URL, cleanFilter);
      if (res?.status) {
        setData(res?.data || []);
        setMeta(res?.count || 0);
      } else {
        setData([]);
        setMeta(0);
      }
    } catch (err) {
      console.error("Error loading data:", err);
      setData([]);
      setMeta(0);
    } finally {
      setIsloading(false);
    }
  };

  const showPreview = (val: any) => {
    setItem(val);
    setPreview(true);
  };

const onChangeDate = (date: any, datestring: any) => {
  const newFilter = { 
    ...filter, 
    createdAt: date, 
    start: 0 
  };
  setPage(1);
  updateUrlAndFilter(newFilter, 1);
};

const updateUrlAndFilter = (newFilter: any, newPage: number) => {
  const params = new URLSearchParams();
  
  params.set('page', String(newPage));
  params.set('limit', String(newFilter.limit));
  
  Object.entries(newFilter).forEach(([key, value]) => {
    if (value !== undefined && value !== null && key !== 'start' && key !== 'limit') {
      if (key === 'createdAt' && value instanceof Date) {
        // Format date as YYYY-MM-DD without timezone conversion
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, '0');
        const day = String(value.getDate()).padStart(2, '0');
        params.set('date', `${year}-${month}-${day}`);
      } else {
        params.set(key, String(value));
      }
    }
  });

  navigation(`?${params.toString()}`, { replace: true });
  setFilter(newFilter);
};
  const editionChange = (edition: any) => {
    const newFilter = { 
      ...filter, 
      edition: edition || undefined,
      start: 0 
    };
    setPage(1);
    updateUrlAndFilter(newFilter, 1);
  };

  const onPageChange = (newPage: number, newPageSize: number) => {
    window.scrollTo(0, 0);
    
    let take = newPage === 1 ? 0 : (newPage - 1) * newPageSize;
    
    setPage(newPage);
    setPageSize(newPageSize);
    
    let filters = {
      ...filter,
      start: take,
      limit: newPageSize,
    };
    
    updateUrlAndFilter(filters, newPage);
  };

  const handleItemUpdate = async (url: any, updateData: any, successMessage: any) => {
    try {
      const res: any = await PUT(url, { data: updateData });
      if (res?.data?.id) {
        message.success(successMessage);
        loadData();
      } else {
        message.error("Something went wrong...!");
      }
    } catch (error) {
      console.error("Error updating item:", error);
      message.error("Something went wrong...!");
    }
  };

  const UndoTrash = (val: any) => {
    const url = API.EPAPER_EDIT + `${val.id}`;
    handleItemUpdate(url, { is_deleted: false }, "Successfully recovered from trash");
  };

  const addToTrash = (val: any) => {
    const url = API.EPAPER_EDIT + `${val.id}`;
    handleItemUpdate(url, { is_deleted: true }, "Successfully moved to trash");
  };

  const onDelete = async (val: any) => {
    try {
      const url = API.EPAPER_DELETE + `${val}`;
      const response = await DELETE(url);
      if (response) {
        message.success("Successfully deleted");
        if (data.length === 1 && page > 1) {
          const newPage = page - 1;
          const newStart = newPage === 1 ? 0 : (newPage - 1) * pageSize;
          const newFilter = { ...filter, start: newStart };
          setPage(newPage);
          updateUrlAndFilter(newFilter, newPage);
        } else {
          loadData();
        }
      }
    } catch (error) {
      console.error("Error deleting item:", error);
      message.error("Something went wrong...!");
    }
  };

  return (
    <div
      style={{
        height: "90vh",
        overflow: "scroll",
        scrollbarWidth: "none",
      }}
    >
      <PageHeader title={"E-Paper"} length={`${meta} Total, ${data.length} Current Page`}>
        <Select
          placeholder="Edition"
          showSearch={true}
          style={{ width: 200 }}
          allowClear
          value={filter.edition}
          filterOption={(input: any, option: any) =>
            option?.children?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0
          }
          onChange={editionChange}
        >
          {editons?.map((item) => (
            <Select.Option value={item} key={item}>
              {item}
            </Select.Option>
          ))}
        </Select>
        &nbsp;
        <DatePicker 
          allowClear 
          style={{ width: 200 }} 
          value={filter.createdAt}
          onChange={onChangeDate} 
        />
        &nbsp;
        <Button
        style={{backgroundColor:"#b72c6f"}}
          type="primary"
          onClick={() => navigation("/Auth/EpaperForm/create")}
        >
          Add New + 
        </Button>
      </PageHeader>
      <div>
        {isloading ? (
          <Loadingbox />
        ) : (
          <DataTable
            data={data}
            page={page}
            pagesize={pageSize}
            meta={meta}
            refresh={loadData}
            onTrash={addToTrash}
            unTrash={UndoTrash}
            onDelete={onDelete}
            onEdit={(val:any) => navigation(`/Auth/EpaperForm/${val?.id}`)}
            onPageChange={onPageChange}
            showPreview={showPreview}
          />
        )}
      </div>
      {preview && (
        <Preview
          item={item}
          open={preview}
          onCancel={() => setPreview(false)}
        />
      )}
    </div>
  );
}

export default EPaperScreeen;